'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import { Button } from '@/ui/buttons/button/Button.client'
import { Icon } from '@/ui/icons/icon/Icon'
import { useToast } from '@/ui/toast/Toast'
import { useEffect, useState } from 'react'

export type ShareButtonProps = {
  /** The product name */
  productName: string
}

export function ShareButton({ productName }: ShareButtonProps): React.ReactNode | null {
  const { t } = useTranslation(['productPage'])
  const toast = useToast()
  const toastTitle = t('productPage:shared.toast.titles.success')
  const toastMessage = productName
    ? t('productPage:shared.toast.messages.success', { productName })
    : toastTitle

  const [canBeDisplayed, setCanBeDisplayed] = useState(true)

  const handleShare = async () => {
    pushToGtmDataLayer({
      event: 'gaEvent',
      eventCategory: 'fiche article / produit',
      eventAction: 'clic cta',
      eventLabel: 'copier',
    })

    await navigator.clipboard.writeText(window.location.href)

    toast.success({
      title: toastTitle,
      message: toastMessage,
    })
  }

  useEffect(() => {
    if (!navigator.clipboard) {
      setCanBeDisplayed(false)
    }
  }, [])

  if (!canBeDisplayed) {
    return null
  }

  return (
    <Button
      className="embed:hidden"
      isRound
      variant="tertiary"
      size="sm"
      onPress={handleShare}
      iconLeft={<Icon.Files />}
    >
      {t('productPage:shared.label')}
    </Button>
  )
}
